// src/components/Hero.js
import React from 'react';
import '../css/Hero.css'; // (Optional) if you want separate CSS for this section

const Hero = () => {
  return (
    <section className="hero">
      <div className="hero-content">
        <h1>Hello, I’m Oz, a Full Stack Developer!</h1>
        <p>Building scalable and secure web applications that enhance user experiences.</p>
        <a href="#contact" className="hero-cta">Work With Me</a>
      </div>
    </section>
  );
};

export default Hero;
